export const GST_NUMBER = "12ABCDE1234F5G6";
